import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import cartSelector from "../../../redux/selectors/cart.selector";
import customerSelector from "../../../redux/selectors/customer.selector";
import commonService from "../../../services/common-service";
import Breadcrumb from "../../../wrappers/breadcrumb/Breadcrumb";
import CheckoutRoot from "./checkout-root";
import UserRoot from "./user-root";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import orderSelector from "../../../redux/selectors/order.selector";
import CartActions from "../../../redux/actions/cart.actions";
import { Link } from "react-router-dom";
import "./checkout.scss";
import EmptyCheckout from "./empty-checkout";

const Checkout = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const cartList = useSelector(cartSelector.cartList);
  const isCartLoaded = useSelector(cartSelector.isCartLoaded);
  const isCustomerLoggedIn = useSelector(customerSelector.isCustomerLoggedIn);
  const isGuestFlow = useSelector(customerSelector.isGuestFlow);
  const [showLoadingModal, updateShowLoadingModal] = useState(true);
  const orderLoading = useSelector(orderSelector.orderLoading);
  const isCartValidated = useSelector(cartSelector.isCartValidated);
  const [isCheckoutValidated, setIsCheckoutValidated] = useState(false);
  const [initialCartList, setInitialCartList] = useState([]);
  useEffect(() => {
    if (orderLoading) {
      updateShowLoadingModal(true);
      commonService.scrollToTop();
    } else {
      updateShowLoadingModal(false);
    }
  }, [orderLoading]);

  useEffect(() => {
    if (!isCheckoutValidated && cartList.length > 0) {
      // dispatch(CartActions.validateCartProductsAction(cartList,history))
      setInitialCartList([...cartList]);
      setIsCheckoutValidated(true);
    } else {
      if (cartList.length !== initialCartList.length) {
        // alert("NOT VALID")
      }
    }
  }, [cartList]);

  const showLogin = () => {
    dispatch({
      type: "UPDATE_GUEST_FLOW",
      payload: false,
    });
    dispatch({
      type: "SHOW_OTP_LOGIN_MODAL",
      payload: true,
    });
  };

  useEffect(() => {
    if (!isGuestFlow && !isCustomerLoggedIn) {
      showLogin();
    } else {
      dispatch({
        type: "SHOW_OTP_LOGIN_MODAL",
        payload: false,
      });
    }
  }, [isCustomerLoggedIn, isGuestFlow]);

  useEffect(() => {
    commonService.scrollToTop();
    // dispatch(CartActions.validateCartProductsAction(cartList,history))
    // dispatch(CartActions.updateShippingChargeAction(0))
  }, []);
  return (
    <>
      <div className="checkout-area pb-100 checkout-page">
        <div className="container">
          {showLoadingModal ? (
            <div className="loading-order">
              <img src="/assets/images/loading.gif" />
              <h3>Please wait while your order is getting placed.</h3>
            </div>
          ) : (
            <>
              <header className="header">
                <h1>
                  {!isCustomerLoggedIn ? "Checkout as Guest" : ""}
                </h1>
                <p>
                  {!isCustomerLoggedIn
                    ? "Enter your details to finish your order."
                    : "We've pre-filled your saved information."}
                </p>
              </header>
              {!isCustomerLoggedIn && (
                <div className="login-cta">
                  <strong onClick={showLogin}>Login</strong> for a faster
                  checkout.
                </div>
              )}
              {cartList && cartList.length >= 1 ? (
                <CheckoutRoot orderLoading={orderLoading} />
              ) : (
                <div className="row">
                  <div className="col-lg-12">
                    <EmptyCheckout Link={Link} />
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Checkout;
